
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" v-on="$listeners" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.326 2.26L5.29 4.296a.41.41 0 10.58.58L8.319 2.43a3.502 3.502 0 014.157 5.545l-2 2L8 12.45 5.525 9.975l-2-2A3.5 3.5 0 017.326 2.26z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M9.39 12.085l.028-.024c2.07.184 3.582.758 3.582 1.439 0 .829-2.239 1.5-5 1.5s-5-.671-5-1.5c0-.68 1.511-1.255 3.582-1.439l.029.024C5.653 12.21 5 12.461 5 12.75c0 .414 1.343.75 3 .75s3-.336 3-.75c0-.289-.653-.54-1.61-.665z"></path>
    </svg>
  </template>
  <script>
    export default {
      name: "IconLocation2",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    };
  </script>
